export const uppercase = {
    bind(el) {
        el.addEventListener('input', function(event) {
          const currentValue = event.target.value;
          const uppercasedValue = currentValue.toUpperCase();
    
          // Solo actualiza el valor si ha cambiado
          if (currentValue !== uppercasedValue) {
            event.target.value = uppercasedValue;
            el.dispatchEvent(new Event('input')); // Disparar evento 'input' solo si es necesario
          }
        });
      }
}